function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import MuiButton from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

var ButtonComponent = function ButtonComponent(props) {
  var _classnames;

  var classesProp = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      disabled = props.disabled,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'contained' : _props$variant,
      fullWidth = props.fullWidth,
      others = _objectWithoutProperties(props, ["classes", "color", "disabled", "size", "variant", "fullWidth"]);

  var isDanger = color === 'danger';

  var containedDangerClass = classesProp.containedDanger,
      containedDangerDisabledClass = classesProp.containedDangerDisabled,
      containedFullWidthClass = classesProp.containedFullWidth,
      containedFullWidthDangerClass = classesProp.containedFullWidthDanger,
      classes = _objectWithoutProperties(classesProp, ["containedDanger", "containedDangerDisabled", "containedFullWidth", "containedFullWidthDanger"]);

  return (
    /*#__PURE__*/
    React.createElement(MuiButton, _extends({
      classes: _objectSpread(_objectSpread({}, classes), {}, {
        contained: classnames(classes.contained, (_classnames = {}, _defineProperty(_classnames, containedDangerClass, isDanger), _defineProperty(_classnames, containedDangerDisabledClass, isDanger && disabled), _defineProperty(_classnames, containedFullWidthClass, fullWidth && color === 'default'), _defineProperty(_classnames, containedFullWidthDangerClass, fullWidth && isDanger), _classnames))
      }),
      fullWidth: fullWidth,
      color: isDanger ? undefined : color,
      disabled: disabled,
      size: size,
      variant: variant
    }, others))
  );
};

var styles = function styles(theme) {
  return {
    root: {},
    label: {},
    contained: {
      // Contained by itself doesn't do anything, but along with danger it'll apply the color
      '&$containedDanger': {
        color: theme.palette.error.main
      }
    },
    disabled: {},
    containedDanger: {},
    containedDangerDisabled: {
      opacity: 0.5
    },
    // Adding a border and slight blue background to default color
    containedFullWidth: {
      backgroundColor: theme.colors.theme50,
      border: "1px solid ".concat(theme.colors.neutral400)
    },
    // Adding a red border and slight red background to danger color
    containedFullWidthDanger: {
      backgroundColor: theme.colors.red50,
      border: "1px solid ".concat(theme.palette.error.main)
    }
  };
};

export var Button = withStyles(styles)(ButtonComponent);
Button.dsuiName = 'Button';